<div class="content">
	<div>
		<div class="form-group row">
			<label class="col-md-4">Browse to upload a file</label>
			<div class="col-md-8">
				<label *ngIf="!isUploading" class="btn btn-success">
					Upload files
					<input (change)="PerformUpload($event)" type="file" class="form-control-file" multiple>
				</label>
				<button *ngIf="isUploading" class="btn btn-success" disabled>
					Uploading...
				</button>
				<span *ngIf="uploadSuccess" class="message-good ml-3 align-top">{{uploadSuccess}}</span>
				<span *ngIf="uploadError" class="message-bad ml-3 align-top">{{uploadError}}</span>
			</div>
		</div>
	</div>
	<div *ngIf="listing">
		<h5>Files in S3</h5>
		<div class="directories">
			<!-- Note: currently this only supports 1 deep which should be all we ever have. But we'll show the directories anyway -->
			<div *ngFor="let dir of listing.directories" class="listing-item">
				<i class="icon-folder"></i> {{dir}}
			</div>
		</div>
		<div class="files">
			<div *ngFor="let file of listing.files" class="listing-item">
				<a (click)="DownloadFile(file)" href="javascript:void(0)"><i class="icon-doc"></i> {{file}}</a>
				<app-action-button [action]="DeleteFile" [args]="[file]" [context]="this" title="Delete file" btnClass="btn-icon btn-danger btn-flush btn-sm"
					confirm="Delete this file from the control bucket?" processing="..."><i class="icon-trash"></i></app-action-button>
			</div>
		</div>
	</div>
</div>